var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_1827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5483 15.7964H0.502841C0.471502 15.7964 0.440449 15.7902 0.411496 15.7783C0.382543 15.7664 0.356252 15.7489 0.334092 15.7269C0.311933 15.7049 0.294378 15.6787 0.282386 15.6499C0.270393 15.6211 0.264179 15.5903 0.264179 15.5591C0.264179 15.5279 0.270393 15.4971 0.282386 15.4683C0.294378 15.4395 0.311933 15.4133 0.334092 15.3913C0.356252 15.3693 0.382543 15.3518 0.411496 15.3399C0.440449 15.328 0.471502 15.3218 0.502841 15.3218H17.5483C17.6116 15.3218 17.6723 15.3468 17.717 15.3913C17.7618 15.4358 17.787 15.4962 17.787 15.5591C17.787 15.622 17.7618 15.6824 17.717 15.7269C17.6723 15.7714 17.6116 15.7964 17.5483 15.7964Z",
    fill: "#101331",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92612 13.9324C4.88151 13.9447 4.8344 13.9447 4.78978 13.9324C4.75885 13.9119 4.73336 13.8841 4.71555 13.8516C4.69774 13.8191 4.68809 13.7829 4.68746 13.7459L4.50852 10.9748C4.49335 10.9251 4.49335 10.8719 4.50852 10.8222L11.3267 0.3646C11.3439 0.338313 11.3662 0.315636 11.3923 0.297978C11.4184 0.28032 11.4477 0.267973 11.4786 0.261667C11.5096 0.255362 11.5414 0.255233 11.5724 0.261254C11.6034 0.267275 11.6329 0.279319 11.6591 0.296737L14.446 2.09334C14.4731 2.10998 14.4962 2.1323 14.5139 2.15862C14.5315 2.18494 14.5432 2.21469 14.5483 2.24593C14.5607 2.27396 14.5671 2.30425 14.5671 2.3349C14.5671 2.36554 14.5607 2.39583 14.5483 2.42386L7.73008 12.8816C7.70378 12.9233 7.66505 12.9559 7.61928 12.9748L5.00285 13.9577L4.92612 13.9324ZM4.99432 10.9748L5.14772 13.3476L7.38067 12.5001L14.0199 2.33066L11.642 0.796811L4.99432 10.9748Z",
    fill: "#101331",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_1827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcp);
export default __webpack_public_path__ + "static/media/ecp.9b7ee510b10b0c483140ff52ac6cacca.svg";
export { ForwardRef as ReactComponent };